import { render } from "./BundlePrice.vue?vue&type=template&id=ca1628f6"
import script from "./script/index.js?vue&type=script&lang=js&external"
export * from "./script/index.js?vue&type=script&lang=js&external"

const cssModules = {}
import style0 from "./BundlePrice.vue?vue&type=style&index=0&id=ca1628f6&lang=scss&module=true"
cssModules["$style"] = style0
import "./BundlePrice.vue?vue&type=style&index=1&id=ca1628f6&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__